export const HEALTH_NAV = [
  {
    "title": "Asuransi Kesehatan",
    "link": "#",
    "childItems": [
      {
        "title": "Asuransi Kesehatan Terbaik",
        "link": "/produk/asuransi-kesehatan/",
      },
      {
        "title": "Asuransi Kesehatan Orangtua",
        "link": "/produk/asuransi-kesehatan/orangtua/",
      },
      {
        "title": "Asuransi Kesehatan Keluarga",
        "link": "/produk/asuransi-kesehatan/keluarga/",
      },
      {
        "title": "Asuransi Kesehatan Anak",
        "link": "/produk/asuransi-kesehatan/anak/",
      },
      {
        "title": "Asuransi Rawat Jalan",
        "link": "/produk/asuransi-kesehatan/rawat-jalan/",
      },
      {
        "title": "Asuransi Melahirkan",
        "link": "/produk/asuransi-kesehatan/melahirkan/",
      },
      {
        "title": "Asuransi Gigi",
        "link": "/produk/asuransi-kesehatan/gigi/",
      },
      {
        "title": "Hospital Cash Plan",
        "link": "/produk/asuransi-kesehatan/hospital-cash-plan/",
      },
      {
        "title": "Asuransi Karyawan",
        "link": "/produk/asuransi-karyawan/",
      }
    ],
  },
];